import { useEffect, useState } from 'react';
import { useCurrentUser } from '../../../utils/auth/useCurrentUser';
export function useUserState(forcedUserState) {
    const [userState, setUserState] = useState('loading');
    const user = useCurrentUser();
    useEffect(() => {
        if (forcedUserState) {
            setUserState(forcedUserState);
        }
        else {
            setUserState(user
                ? (user.hasAccess && 'claimed') || 'unclaimed'
                : (user === undefined && 'loading') || 'loggedOut');
        }
    }, [user, forcedUserState]);
    return userState;
}
//# sourceMappingURL=useUserState.js.map